import { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { ApiService } from "../../../service/ApiService";

import { headersObjectArray, validateUrl } from "../../../utils/helpers";
import { collectServerSideState } from "../../../utils/helpers/collectServerSideState";

import { useHeaderViewerAdapter, useToolsScan } from "../../../hooks";

import { BoxWrapper, Container } from "../../../components";
import { Input, ProgressBar } from "../../../components";
import { Seo } from "../../../components/Seo/Seo";
import AccordionTable from "../../../components/common/AccordionTable";
import { Faq } from "../../../components/common/Faq/Faq";
import HeadUpperSeo from "../../../components/common/HeadUpperSeo";
import Spinner from "../../../components/common/Spinner";
import { Button } from "../../../components/ui/Button/Button";

import { Section } from "../../../components/common/Section/Section.styled";
import {
  ButtonWrapper,
  InputWrapper,
  TableWrapper,
  Wrapper,
} from "./HeaderViewer.styled";

const HeaderViewer = () => {
  const [httpHeader, setHttpHeader] = useState([]);

  const { showLoader, inputValue, setShowLoader, setInputValue } =
    useToolsScan();

  const { t } = useTranslation();

  const {
    headerData,
    renderRowContent,
    renderHeaderTitle,
    renderDropdownContent,
  } = useHeaderViewerAdapter();

  const handleScan = async e => {
    e.preventDefault();

    const url = inputValue.trim();

    if (!url) {
      return toast.error(t("httpHeaders.emptyInputError"), { toastId: 1 });
    }

    const { isValidUrl } = validateUrl(url);

    if (!isValidUrl) {
      return toast.error(t("httpHeaders.invalidUrl"), { toastId: 1 });
    }

    setShowLoader(true);

    const res = await ApiService.getHeaders(url);

    if (res.headers) {
      const headers = headersObjectArray(res.headers);
      setHttpHeader(headers);
    }

    setTimeout(() => {
      setShowLoader(false);
    }, 4500);
  };

  const handleChange = e => {
    const { value } = e.target;

    setInputValue(value);
  };

  return (
    <>
      <Section variant="start">
        <Container>
          <HeadUpperSeo />

          {showLoader && <ProgressBar />}

          <BoxWrapper>
            <form data-testind-id="http-headers-scan-form">
              <Wrapper>
                <InputWrapper>
                  <Input
                    className="grey"
                    fullWidth
                    placeholder={t("httpHeaders.placeHolder")}
                    onChange={handleChange}
                    data-testind-id="http-headers-url-input"
                  />
                </InputWrapper>

                <ButtonWrapper>
                  <Button
                    type="submit"
                    fullWidth
                    disable={showLoader}
                    onClick={handleScan}
                    data-testind-id="http-headers-scan-button"
                  >
                    {showLoader ? (
                      <Spinner text={t("httpHeaders.scanButton")} />
                    ) : (
                      t("httpHeaders.scanButton")
                    )}
                  </Button>
                </ButtonWrapper>
              </Wrapper>
            </form>

            {!showLoader && httpHeader.length > 0 && (
              <TableWrapper>
                <AccordionTable
                  data={httpHeader}
                  headerData={headerData}
                  renderDropdownContent={renderDropdownContent}
                  renderHeaderTitle={renderHeaderTitle}
                  renderRowContent={renderRowContent}
                  showStatus={false}
                />
              </TableWrapper>
            )}
          </BoxWrapper>
        </Container>
      </Section>

      <Faq />
      <Seo />
    </>
  );
};

HeaderViewer.getServerSideState = async (store, params) => {
  await collectServerSideState(store, params);
};

export default HeaderViewer;
